import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { useUserContext } from '@nrdy-marketing-engine/server/src/user/context';
import { useEffect } from 'react';

const useFetchClientData = (setValue) => {
  const { user } = useUserContext();

  useEffect(() => {
    const fetchClientData = async () => {
      if (user?.entity.client_uuid) {
        try {
          const result = await apiFetch(`/vtwa/v5/clients/${user.entity.client_uuid}`);
          const phoneNumber = result?.phone_numbers?.[0]?.value;
          const zip = result?.address?.zip;

          // 0000000000 is sometimes used as the default client phoneNumber
          if (phoneNumber && !/^0000000000/.test(phoneNumber)) {
            setValue('phoneNumber', phoneNumber, { shouldValidate: true });
          }

          if (zip) {
            setValue('zipCode', zip, { shouldValidate: true });
          }
        } catch (error) {
          console.error('Error fetching client data:', error);
        }
      }
    };

    fetchClientData();
  }, [user, setValue]);
};

export default useFetchClientData;
